export default {
  title: {
    id: 'asp_action_bar_ship_back_item_step_title',
    defaultMessage: 'Repair, replace, or return an item',
  },
  intro: {
    id: 'asp_action_bar_ship_back_item_step_introduction',
    defaultMessage:
      'Enter the shipping details if the item hasn’t been shipped yet.',
  },
  shippingDetails: {
    id: 'asp_action_bar_ship_back_item_step_shipping_detail_radio_label',
    defaultMessage: 'Add shipping information (optional)',
  },
}
